import React from 'react';

import Typography, { IPropTypes as TypographyProps } from 'e100-react-components/lib/components/Typography';

import { CheckboxListItemProps } from './ui';

export const Label = ({
  title,
  subtitle,
  labelColor = 'default'
}: LabelProps) => {
  return (
    <>
      <Typography
        color={labelColor as TypographyProps['color']}
      >
          {title}
      </Typography>
      {
        subtitle && (
          <Typography
            variant={'caption'}
          >
              {subtitle}
          </Typography>
        )
      }
    </>
  );
};

interface LabelProps extends Pick<
  CheckboxListItemProps,
  'title' | 'subtitle' | 'labelColor'
> {}

